module.exports = __webpack_public_path__ + "img/suppliercheck-logo.7fa91fcf.png";